import type { AccessGrant } from "../api/rest";

/**
 * The subject holding the org_unit/admin grant on this tenant, or null (ADR 180).
 * Only ever surfaces a tenant (org_unit) admin — the global-admin realm role isn't a
 * grant, so it can't appear here and can't be changed through the tenant-admin UI.
 */
export function tenantAdminSubject(grants: AccessGrant[], orgUnitId: string): string | null {
  const g = grants.find(
    (x) => x.scopeType === "org_unit" && x.scopeId === orgUnitId && x.role === "admin",
  );
  return g ? g.subject : null;
}

/** Display label for a tenant admin (ADR 181): resolved email, else name, else the raw sub. */
export function idpUserLabel(
  user: { email: string; name: string } | null | undefined,
  subFallback: string | null,
): string {
  return user?.email || user?.name || subFallback || "—";
}
